/** Tracé commun : une valeur absente interrompt toujours une série. */
export interface PlotPoint { readonly x: number; readonly y: number | undefined }
export interface Projection { readonly toX: (x: number) => number; readonly toY: (y: number) => number }

export function plotPaths(points: readonly PlotPoint[], projection: Projection): string {
  const paths: string[] = [];
  let run: string[] = [];
  const flush = (): void => {
    if (run.length > 1) paths.push(`<path d="M ${run.join(" L ")}" fill="none" />`);
    run = [];
  };
  for (const point of points) {
    if (point.y === undefined || !Number.isFinite(point.y) || !Number.isFinite(point.x)) flush();
    else run.push(`${projection.toX(point.x).toFixed(2)},${projection.toY(point.y).toFixed(2)}`);
  }
  flush();
  return paths.join("");
}

/** Forme du modèle, indépendante de la couleur et du trait plein de prédiction. */
export function plotMarker(rank: number, x: number, y: number): string {
  const px = x.toFixed(2);
  const py = y.toFixed(2);
  if (rank % 3 === 0) return `<circle class="verlet-model-mark" cx="${px}" cy="${py}" r="3" />`;
  if (rank % 3 === 1) return `<rect class="verlet-model-mark" x="${(x - 3).toFixed(2)}" y="${(y - 3).toFixed(2)}" width="6" height="6" />`;
  return `<polygon class="verlet-model-mark" points="${px},${(y - 4).toFixed(2)} ${(x + 4).toFixed(2)},${(y + 3).toFixed(2)} ${(x - 4).toFixed(2)},${(y + 3).toFixed(2)}" />`;
}

export function plotMarkers(points: readonly PlotPoint[], rank: number, projection: Projection): string {
  const every = Math.max(1, Math.ceil(points.length / 12));
  return points.filter((_, index) => index % every === 0 || index === points.length - 1)
    .map((point) => point.y === undefined || !Number.isFinite(point.y) ? "" : plotMarker(rank, projection.toX(point.x), projection.toY(point.y)))
    .join("");
}

export const MODEL_SYMBOLS = ["○", "□", "△"] as const;
